import { ClassroomInfo } from '@descomplica/dex-models';

export type ClassroomProgress = {
  classroomId: number;
  progress: number;
};

export interface ClassroomState {
  classrooms: { [key: string]: ClassroomInfo };
  studentsIds: { [classroomId: number]: number[] };
  isLoadingClassroomData: boolean;
  isLoadingRevisionLists: { [classroomId: number]: boolean };
  isLoadingClassroomAppointments: { [classroomId: number]: boolean };
  isLoadingClassroomMaterials: { [classroomId: number]: boolean };
  classroomsProgressMap: { [classroomId: number]: ClassroomProgress };
  allClassroomsByPeriod: { [key: string]: any };
  currentClassroomsByPeriod: any;
}

const state: ClassroomState = {
  classrooms: {},
  studentsIds: {},
  isLoadingClassroomData: false,
  isLoadingRevisionLists: {},
  isLoadingClassroomAppointments: {},
  isLoadingClassroomMaterials: {},
  classroomsProgressMap: {},
  allClassroomsByPeriod: {},
  currentClassroomsByPeriod: {},
};

export default state;
